export const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:3005/';

export const FETCH_IP_URL = 'https://api64.ipify.org?format=json';

export const ORS_URL = 'https://api.openrouteservice.org/v2/directions/driving-car/geojson';

export const MARKETPLACE_URL = 'https://marketplace.premiumoilfield.com/Login';
